module.exports = __webpack_public_path__ + "media/giftcards/GC-HowItWorks-2-7a4d03ef.svg";